var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AccountCards", {
    attrs: { "client-data": _vm.clientData || _vm.distributorData },
    on: {
      "update-logo": data => _vm.updateLogo(data),
      "update-client": data => _vm.updateUser(data)
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }